var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": true,
        "modal-append-to-body": false,
        visible: _vm.payOfflineDialogVisible,
        center: "",
        title: "对公转账",
        width: "50%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.payOfflineDialogVisible = $event
        },
      },
    },
    [
      _c("PayResult", {
        attrs: {
          "insure-type": _vm.payData.insureType,
          "is-add": _vm.payData.isAdd,
          "order-id": _vm.payData.currentOderId,
          "pay-source": 2,
          "pay-types-data": _vm.settingConfig.payTypes,
          "pre-pay-notice-data": _vm.settingConfig.prePayNotice,
          "product-id": _vm.payData.productId,
          "source-product-id": _vm.payData.sourceProductId,
          "span-width": 20,
          "temp-order-id": _vm.payData.orderId,
          "total-price": _vm.payData.totalPrice,
        },
        on: { onToPolicyDetail: _vm.onPaySuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }